import { render, staticRenderFns } from "./LiveGuide.vue?vue&type=template&id=34b33508&scoped=true&"
import script from "./LiveGuide.vue?vue&type=script&lang=ts&"
export * from "./LiveGuide.vue?vue&type=script&lang=ts&"
import style0 from "./LiveGuide.vue?vue&type=style&index=0&id=34b33508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b33508",
  null
  
)

export default component.exports